export default __webpack_public_path__ + "static/media/login-lock.82f6bdb1.svg";